.root {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 12px 14px;
  font-size: 13px;
}
.tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(76px, 1fr));
  gap: 8px;
}
.tile {
  display: flex;
  flex-direction: column;
  padding: 8px 10px;
  border: 1px solid var(--surface-edge);
  border-radius: 4px;
  background: var(--field);
}
.tileValue {
  font-size: 20px;
  font-weight: 600;
  font-family: var(--font-mono);
}
.tileLabel {
  font-size: 10.5px;
  color: var(--ink-faint);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.heading {
  margin: 14px 0 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--ink-soft);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.bars {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.bar {
  display: grid;
  grid-template-columns: 84px 1fr 28px;
  align-items: center;
  gap: 8px;
}
.barLabel {
  font-family: var(--font-mono);
  font-size: 11.5px;
  color: var(--ink-soft);
}
.barTrack {
  height: 8px;
  background: var(--field);
  border-radius: 4px;
  overflow: hidden;
}
.barFill {
  display: block;
  height: 100%;
  background: var(--focus);
  opacity: 0.75;
}
.barValue {
  text-align: right;
  font-family: var(--font-mono);
  font-size: 11.5px;
}
.empty,
.foot {
  margin: 8px 0 0;
  color: var(--ink-faint);
  font-size: 12px;
}
